import { render, staticRenderFns } from "./create-stock-rotations-dialog.vue?vue&type=template&id=72060ea8&scoped=true&"
import script from "./create-stock-rotations-dialog.vue?vue&type=script&lang=js&"
export * from "./create-stock-rotations-dialog.vue?vue&type=script&lang=js&"
import style0 from "./create-stock-rotations-dialog.vue?vue&type=style&index=0&id=72060ea8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72060ea8",
  null
  
)

export default component.exports